import React, {useEffect} from 'react';
import {Routes, Route, useLocation} from 'react-router-dom';

import './styles/styles.css';
import Header from './constants/header';
import Footer from './constants/footer';
import Home from './pages/home';
import Dates from './pages/dates';
import Info from './pages/information';
import Team from './pages/team';
import Stats from './pages/stats';
import Contact from './pages/contact';
import Shout from './pages/shout';
import Cookies from './pages/cookies';
import Privacy from './pages/privacy';
import Play from './pages/play';

function App() {

const location = useLocation();

  useEffect(() => {
    if(location.pathname === "/team") {
      document.querySelector('[id^="kofi-widget-overlay-"]').style.display = "block";
    } else {
      document.querySelector('[id^="kofi-widget-overlay-"]').style.display = "none";
    }
  }, [location]);

  return (
    <div className="App">
      <Header />
      <main>
        <Routes>
          <Route path = "/" exact element={<Home />} />
          <Route path = "/dates" element={<Dates />} />
          <Route path = "/information" element={<Info />} />
          <Route path = "/team" element={<Team />} />
          <Route path = "/stats" element={<Stats />} />
          <Route path = "/contact" element={<Contact />} />
          <Route path = "/shout" element={<Shout />} />
          <Route path = "/cookies" element={<Cookies />} />
          <Route path = "/Privacy" element={<Privacy />} />
          <Route path = "/Play" element={<Play />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
